<script>
export default {
  props: {
    id: { default: "" },
    url: { default: "" },
    origin: { default: null },
    default: { default: false },
  },

  data() {
    return {
      favorited: false,
      wasFavorited: false,
      similarAccounts: [],
    };
  },

  mounted() {
    this.favorited = this.default;

    this.$root.$on("toggling-favorite-account", () => {
      this.similarAccounts = [];
    });

    this.$root.$on("toggled-favorite-account", (data) => {
      if(data.id === this.id) {
        this.favorited = data.favorited
      }
    });
  },

  methods: {
    toggleFavorite: function () {
      this.$root.$emit("toggling-favorite-account");

      this.wasFavorited = false;

      axios
        .post(this.url, {
          origin: this.origin,
        })
        .then((response) => {
          this.wasFavorited = this.favorited = response.data.favorited;

          this.$root.$emit("toggled-favorite-account", {
            id: this.id,
            favorited: this.favorited,
          });

          this.similarAccounts = this.favorited
            ? response.data.similar_accounts
            : [];
        });
    },
  },
};
</script>
